<template>
  <a class="postGridItemContainer w-100 h-100 flex-col-center-start" :href="post.link">
    <AspectWrapper :aspectRatio="275 / 300">
      <img v-if="post.thumbnail" :alt="post.title" class="postDisplayImage cover" :src="post.thumbnail" />
      <img v-else-if="post.image" :alt="post.title" class="postDisplayImage cover" :src="post.image" />
      <div v-else class="noImageWrapper bg-black w-100 h-100 flex-center">
        <PwccMinimal fill="#FFF" height="100px" width="100px" />
      </div>
    </AspectWrapper>
    <div class="metaContent w-100 flex-1 flex-col-start-between">
      <span class="postGridTitle">
        {{ post.title }}
      </span>
      <span v-if="post.category_name" class="postCategory text-capitalize">
        {{ post.category_name }}{{ canShowPublishedDate ? `: ${post.published_formatted}` : '' }}
      </span>
      <span v-else-if="canShowPublishedDate" class="postDate">{{ post.published_formatted }}</span>
    </div>
  </a>
</template>

<script>
import AspectWrapper from '@js/web/components/misc/AspectWrapper';
import { PwccMinimal } from '@js/web/components/icons';
export default {
  name: 'PostGridItem',
  components: {
    AspectWrapper,
    PwccMinimal
  },
  props: {
    post: {
      type: Object,
      required: true,
    }
  },
  computed: {
    canShowPublishedDate() {
      return this.isNewsroom && this.post.published_formatted;
    },
    isNewsroom() {
      return this.post.type === 'article';
    }
  },
};
</script>

<style lang="scss">
@import '@sass/vue-imports.scss';
.postGridItemContainer {
  background: #FFF;
  border-radius: 10px;
  box-shadow: 0px 6px 50px rgba(202, 205, 207, 0.5);
  overflow: hidden;
  border-bottom: none !important;

  &:hover {
    color: $link-color !important;
    text-decoration: none !important;
    border-bottom: none !important;
    box-shadow: 0px 6px 50px rgba(202, 205, 207, 1);
  }

  .metaContent {
    padding: 14px 16px;

    .postGridTitle {
      color: $dark-gray !important;
      font-weight: 700;
      font-size: 14px;
      line-height: 16px;
      letter-spacing: 0.02em;
      text-align: left;
      width: 100%;
      white-space: initial;
      word-wrap: break-word;
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }

    .postDate, .postCategory {
      color: $corduroy !important;
      font-weight: 700;
      font-size: 12px;
      line-height: 14px;
      letter-spacing: 0.02em;
      margin-top: 24px;
    }
  }
}
</style>